import * as React from 'react';
import styled from 'styled-components';

import { ErrorImage } from '../../components/04error/errorImageComponent';
import { ErrorMessage } from '../../components/04error/errorMessageComponent';
import { TimeoutImage } from '../../components/04error/timeoutImageComponent';
import { TimeoutMessage } from '../../components/04error/timeoutMessageComponent';


type Props = {
    // onClickVoid:(event: React.MouseEvent<HTMLButtonElement>) =>void,
    // languageExchange:any,
}

export const ErrorPage: React.FC<Props> = (props) => {
  const ErrorPageComponent = styled.main`
    text-align: center;
    background-color: #555555;
    color: white;
    font-family: 'Noto Sans JP',sans-serif;
    font-style: normal;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100vh;
  `;
  return (
    //※中身を入れていかないと背景が表示されない 
    <ErrorPageComponent>
         <div>
            <ErrorImage/>
            <ErrorMessage navRoot='2' buttonText='新しいブラウザで開く' errorExplanationText='読み込めませんでした'/>
        </div>
    </ErrorPageComponent>
  );
};